import React, { useState, useEffect } from 'react';
import './App.css';
import './App2.css';
import Name from "./images/Name.png";
import Card3 from "./images/Card3.png"
import Card4 from "./images/Card4.png"
import Nomad from "./images/Nomad2.png"
import CoUsers from "./images/CoUsers3.png"
import Portal from "./images/Portal2.png"
import JoinWaitlistModal from './JoinWaitlistModal';
import Footer from './Footer';


function App() {

  const [isMediaQueryActive, setIsMediaQueryActive] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // Check your media query condition here
      const newMediaQueryStatus = window.innerWidth <= 768;  // Adjust this condition accordingly
      setIsMediaQueryActive(newMediaQueryStatus);
    };

    // Initial check on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <div className="App">
      <header>
        <nav>
          <div className="left-content">
            <img src={Name} alt="" id='header-credvel'/>
          </div>
          <ul>
            <button className='button-waitlist' onClick={openModal}>Join Waitlist</button>
          </ul>
        </nav>

        <JoinWaitlistModal isOpen={isModalOpen} onRequestClose={closeModal} />
      </header>
      <main>
        <section className="hero">
          <div className="hero-text">
            <h1>Travel the world for free with <span class="highlight-text">Credvel</span></h1>
            <p>We are a neo-banking startup that aims to make travel easier for Gen Zs through our flagship credit card.</p>
          </div>
          <div className="hero-image">
            <img src={Card3} alt="Our Card" />
          </div>
        </section>

        <section id='about' className='section'>
          <div className="card-description-container">
            <div className="card-image" >
              <img src={Card4} alt="Our Card" height="400px"/>
            </div>
            <div className="card-description">
              <h1>Introducing Credvel Card</h1>
              <br></br>

              <p>Introducing Credvel, your passport to unparalleled adventures! Our credit card isn't just a piece of plastic; it's your ticket to exclusive travel rewards, shared experiences, and a community that celebrates your journey. With innovative features, unbeatable benefits, and a touch of wanderlust, Credvel transforms every transaction into a memorable adventure.</p>
            </div>
          </div>
        </section>

        {/* <section id='about' className='section'>
        <div className="card-image" >
              <img src={Card4} alt="Our Card" height="400px"/>
            </div>
          <div className="card-description-container">
            <div className="card-description">
              <h1>Introducing Credvel Card</h1>
              <br></br>

              <p>Introducing Credvel, your passport to unparalleled adventures! Our credit card isn't just a piece of plastic; it's your ticket to exclusive travel rewards, shared experiences, and a community that celebrates your journey. With innovative features, unbeatable benefits, and a touch of wanderlust, Credvel transforms every transaction into a memorable adventure.</p>
            </div>
          </div>
        </section> */}

        <section id="section3" className="section">
          <h1>Why choose Us?</h1>
        </section>

        <section id='section-portal' className="section">
          <div className="app-description-container">
            <div className="app-image">
              <img src={Portal} alt="App Interface"/>
            </div>
            <div className="app-description">
              <h1>Integrated Travel Portal</h1>
              <p>Integrated Flight booking and hotel booking portal.</p>
            </div>
          </div>
        </section>

        <section id='section_nomad' className="hero">
          <div className="hero-text">
            <h1>Introducing the Nomad</h1>
            <p>Meet the future of travel booking: the first ever AI assistant tailored to discover and secure your ideal reward trips. Effortless planning, maximized rewards, and journeys tailored to you.</p>
          </div>
          <div className="nomad-image">
              <img src={Nomad} alt="App Interface"/>
          </div>
        </section>

        <section id='section_CoUsers' className="section">
          <div className="app-description-container">
            <div className="app-image">
              <img src={CoUsers} alt="App Interface"/>
            </div>
            <div className="app-description">
              <h1>Shared Credit Card </h1>
              <p>You can decide on 3 additional co-user for your card to collectively earn and enjoy rewards.</p>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="other-benefits">
            <div className="heading">
              <h1>And Many more benefits...</h1>
              <br></br>
              <br></br>
              <ul>
                <li>
                <h2>Premier Rewards</h2>
                </li>
                <li>
                <h2>No Annual Fees</h2>
                </li>
                <li><h2>No Forex Markup Fee</h2></li>
                {/* <li><h2>No Credit Score Needed</h2></li> */}
              </ul>
            </div>
          </div>
        </section> 
      </main>
      <Footer />
    </div>
  );
}

export default App;
